var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommandFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31361 7.0887C6.90183 3.96783 8.31524 1.97794 9.00867 1.33276C9.1099 1.92927 9.524 2.80274 10.0231 3.68525C11.086 5.56439 12.414 7.39569 12.6305 9.54368C13.0387 13.5932 9.8929 14.9359 7.50427 14.6225C1.66675 14.3328 2.4134 7.56932 4.02276 5.91308C4.20514 7.04025 4.69411 7.62021 5.18688 7.89202C5.70987 8.1805 6.20299 7.67564 6.31361 7.0887Z",
    fill: "#E8C746",
    stroke: "#E8C746",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3277 10.3864C7.69153 9.10796 8.3388 8.28731 8.67508 8C9.03406 9.94232 11.2939 11.6194 10.4714 13.4152C10.0101 14.4224 8.81978 14.761 7.85592 14.6448C4.67732 14.5 5.08388 11.1183 5.9602 10.2902C6.01382 10.5945 6.11611 10.819 6.24112 10.9826C6.60437 11.4579 7.16395 10.9618 7.3277 10.3864Z",
    fill: "#F4E5AA",
    stroke: "#F4E5AA",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommandFire);
export default __webpack_public_path__ + "static/media/recommandFire.eaa23908f52831061c2f9f63492a797c.svg";
export { ForwardRef as ReactComponent };